{
  "fr": {
    "marketplace_partner": {
      "contact_me": {
        "button": "Contactez moi!",
        "failure": "Une erreur inattendue s'est produite.",
        "success": "Nous vous contacterons bientôt."
      }
    }
  }
}
